import React, { memo } from "react";
import ReactDOM from "react-dom";
import { FeatureUnavailableProps } from "./types";
import { ZPosition } from "ui/components/Modal/types";
import { Button } from "ui/components/Button/Button";

const zPositionClassName = (zPosition: string) => {
  switch (zPosition) {
    case ZPosition.Bottom:
      return "z-30";
    case ZPosition.Top:
      return "z-50";
    default:
      return "z-40";
  }
};

const FeatureUnavailable: React.FC<FeatureUnavailableProps> = ({ show, title, description, onClose, actions, zPosition = "middle" }) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className={`fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center ${zPositionClassName(zPosition)}`}>
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 animate-fadeIn">
        <div className="text-amber-500 mb-5">
          <svg className="w-14 h-14 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">{title}</h3>
        <p className="text-sm text-gray-500 text-center mb-6">{description}</p>
        <div className="flex justify-center gap-3">
          {actions ?? (
            <Button variant="primary" onClick={onClose}>
              Zatvori
            </Button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default memo(FeatureUnavailable);
